'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var $ = _interopDefault(require('jquery'));
var I18n = _interopDefault(require('../global/i18n.js'));
var A11y = _interopDefault(require('../global/a11y-helpers.js'));
var utils_js = require('../helpers/utils.js');
var FormsAPI = _interopDefault(require('./forms-api.js'));
require('./jquery.serializejson.js');

var ERROR_CONTAINER_SELECTOR = '.marketing-form__messages';
var SUCCESS_MESSAGE_SELECTOR = '.marketing-form__ajax-success';
var INPUT_WRAPPER_SELECTOR = '.marketing-input-wrapper';
var HIDDEN_ON_SUCCESS_SELECTOR = '.marketing-input-wrapper, .marketing-form__hidden-on-success';
var REQUIRED_FIELD_SELECTOR = 'input[required], select[required], textarea[required]';
var FORM_LOADING_CLASS = 'marketing-form--is-loading';
var VISIBLE_CLASS = 'js-is-visible';
var HIDDEN_CLASS = 'js-is-hidden';
var DEFAULT_I18N_SCOPE = 'forms.errors';

var GLOBAL_ERRORS = ['invalid', 'required', 'generic', 'throttled'];

/**
 * Generic AJAX form
 * @param {$DOM} el Element wrapper for form element
 * @param {Array} [validations] array of validation objects: each object must have
  a `name` matching the <input> element's name, and a `fn` that returns an
 object
 * @param {Object} [options] contains `i18nScope` for error message keys
 * @class AjaxForm
 * @namespace ShopifyMarketing
 * @constructor
*/
function AjaxForm(form) {
  var validations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  this.$form = utils_js.isJquery(form) ? form : $(form);
  this.validations = this.collectValidations(validations);
  this.$form.on('submit', this.handleSubmit.bind(this));
  this.$messages = this.$form.find(ERROR_CONTAINER_SELECTOR);
  this.$success = this.$form.find(SUCCESS_MESSAGE_SELECTOR);
  this.url = this.$form.attr('action');
  this.method = this.$form.attr('method');
  this.errors = [];
  this.options = options;
  this.i18nScope = this.options.i18nScope || DEFAULT_I18N_SCOPE;
}

/**
 * Collect Validations
 * @method collectValidations
 * @param {array} validations initial array of validations passed to constructor
 * @return {array} initial array concatenated with validations extracted from
 * required fields
*/
AjaxForm.prototype.collectValidations = function () {
  var validations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  // Handle if the validations are a jQuery wrapped array.
  var extraValidations = typeof validations.get === 'undefined' ? validations : validations.get();

  return this.$form.find(REQUIRED_FIELD_SELECTOR).get().map(function (el) {
    return {
      name: $(el).attr('name'),
      fn: FormsAPI.validatePresent
    };
  }).concat(extraValidations);
};

/**
 * Submit form
 * @method handleSubmit
 * @param {event object} evt event object returned from event handler
*/
AjaxForm.prototype.handleSubmit = function (evt) {
  var fields = this.$form.serializeJSON();

  this.$form.addClass(FORM_LOADING_CLASS);
  evt.preventDefault();
  this.errors = [];
  this.validate(fields);

  if (this.errors.length) {
    this.displayErrors();
    this.$form.removeClass(FORM_LOADING_CLASS);
  } else {
    this.sendData(fields);
  }
};

/**
 * send data to endpoint
 * @method sendData
 * @param {event object} data object to be sent to server
*/
AjaxForm.prototype.sendData = function (data) {
  var self = this;

  return $.ajax({
    url: this.url,
    method: this.method,
    data: data
  }).done(function (result, response, jqxhr) {
    self.handleSuccess(jqxhr);
  }).fail(function (result) {
    self.handleError(result);
  }).always(function () {
    self.$form.removeClass(FORM_LOADING_CLASS);
  });
};

AjaxForm.prototype.handleSuccess = function (jqxhr) {
  if (jqxhr.status < 200 || jqxhr.status >= 300) {
    return;
  }
  this.displaySuccess();
  this.trackSuccess();

  if ($.isFunction(this.options.onSuccess)) {
    this.options.onSuccess.call(this, jqxhr);
  }
};

AjaxForm.prototype.handleError = function (data) {
  var responseJSON = data.responseJSON;
  var errorObject = void 0;

  if (responseJSON && responseJSON.hasOwnProperty('field') && responseJSON.hasOwnProperty('error')) {
    errorObject = responseJSON;
  } else {
    errorObject = {
      field: 'global',
      error: { generic: true }
    };
  }

  this.errors = [errorObject];
  this.trackError();

  this.displayErrors();

  if ($.isFunction(this.options.onError)) {
    this.options.onError.call(this, responseJSON);
  }
};

/**
 * validate fields
 * @method validate
 * @param {object} fields key-value pairs of form data
*/
AjaxForm.prototype.validate = function (fields) {
  this.validations.forEach(function (validation) {
    var error = validation.fn(fields[validation.name]);

    if (_Object$keys(error).length !== 0) {
      this.errors.push({
        field: validation.name,
        error: error
      });
    }
  }, this);
};

/**
 * error template
 * @method errorTemplate
 * @param {object} error error object of format { error: { invalid: true }, field: 'name' }
 * @return {array} array of DOM elements
*/
AjaxForm.prototype.errorTemplate = function (error) {
  var _this = this;

  return _Object$keys(error.error).map(function (key) {
    var span = $('<span class="error"/>');
    var scope = errorKey(error) + '.' + key;
    var translation = I18n.t(_this.i18nScope + '.' + scope, {
      err: error.error,
      defaults: [{ scope: DEFAULT_I18N_SCOPE + '.' + scope }]
    });

    span.text(translation);
    return span;
  });
};

/**
 * display errors
 * @method displayErrors
 */
AjaxForm.prototype.displayErrors = function () {
  this.$messages.empty();

  this.errors.forEach(function (error) {
    var message = void 0;
    if (error.field === 'global') {
      message = this.$messages.last();
    } else {
      message = this.$form.find('[name="' + error.field + '"]').parents(INPUT_WRAPPER_SELECTOR).find(ERROR_CONTAINER_SELECTOR);
    }
    this.errorTemplate(error).forEach(function (errorEl) {
      message.prepend(errorEl);
    });
  }, this);
  this.focusError();
};

AjaxForm.prototype.focusError = function () {
  var firstError = this.errors[0];
  this.$form.find('[name="' + firstError.field + '"]').focus();
};

AjaxForm.prototype.displaySuccess = function () {
  this.$form.find(HIDDEN_ON_SUCCESS_SELECTOR).addClass(HIDDEN_CLASS);
  this.$success.addClass(VISIBLE_CLASS);
  A11y.prototype.pageLinkFocus(this.$success);
};

AjaxForm.prototype.trackSuccess = function () {}; // eslint-disable-line no-empty-function

AjaxForm.prototype.trackError = function () {}; // eslint-disable-line no-empty-function

function errorKey(error) {
  var key = _Object$keys(error.error)[0];
  return GLOBAL_ERRORS.indexOf(key) === -1 ? error.field : 'global';
}

module.exports = AjaxForm;
